import {Box, Flex, Image, keyframes, Text, Button, Icon} from '@chakra-ui/react'
import partTwoImage from '@assets/images/learn/image-part-two.png'
import {BsImage} from 'react-icons/bs'
import {BiSearch} from 'react-icons/bi'
import {AiOutlineStar} from 'react-icons/ai'
import {BsEmojiSmile} from 'react-icons/bs'

const slideUp = keyframes`
from { transform: translateY(20px); opacity: 0; }
to { transform: translateY(0); opacity: 1; }
`

const TopContent = ({
  currentContent,
  phases,
}: {
  currentContent: any
  phases: any
}) => {
  const animation = `${slideUp} 0.5s ease-out`

  const getIndexPhase = () => {
    return phases?.findIndex(
      (item: any) => item?.phase === currentContent?.phase,
    )
  }

  const getIcon = (index: number) => {
    switch (index) {
      case 0:
        return BsImage
      case 1:
        return BiSearch
      case 2:
        return AiOutlineStar
      case 3:
        return BsEmojiSmile
      default:
        return BsImage
    }
  }

  return (
    <Flex height={'200px'} direction="column">
      <Flex>
        <Image src={partTwoImage} alt="part-two" />
        <Box
          padding={'24px'}
          border={'1px solid #D0D5DD'}
          borderRadius={'12px'}
          borderBottomLeftRadius={'none'}
          height={'fit-content'}
          animation={animation}>
          <Text fontSize={'16px'}>{currentContent?.introduction}</Text>
          <Text fontSize={'18px'} fontWeight={600} mt={'8px'} color={'#475467'}>
            {currentContent?.data?.lesson_topic}
          </Text>
          {currentContent?.type === 'USER_IDEA' && (
            <Flex gap={12} mt={4}>
              {phases?.length > 0 &&
                phases?.map((item: any, index: number) => (
                  <Button
                    key={index}
                    pointerEvents={'none'}
                    leftIcon={<Icon as={(getIcon(index) as any) || <></>} />}
                    variant="outline"
                    fontSize={'16px'}
                    fontWeight={'600'}
                    borderRadius="full"
                    bg={index <= getIndexPhase() ? 'blue.50' : 'transparent'}
                    color={index <= getIndexPhase() ? '#007EF5' : '#344054'}
                    border={'1px solid #99CEFF'}
                    borderColor={
                      index <= getIndexPhase() ? '#99CEFF' : '#E4E7EC'
                    }>
                    {item.phase_title}
                  </Button>
                ))}
            </Flex>
          )}
        </Box>
      </Flex>
    </Flex>
  )
}

export default TopContent
